import React, { Component } from 'react';
import TextFields from './TextField-f';


class InputTabs extends Component {
    state = {
        name: {
            eng: true,
            arb: false
        }
    };

    toggleTabsHandler = isEng => {
        this.setState({ name: {arb: !isEng, eng: isEng} })
    };


    render() {
        const { name, floatingLabelText, values, onChange, onBlur, errors, touched } = this.props;
        let fields = (
            <React.Fragment>
                <TextFields hide={ this.state.name.arb }
                            onBlur={ onBlur }
                            error={touched && touched[`${name}_en`] && errors && errors[`${name}_en`] }
                            onChange={ e => onChange(`${name}_en`, e.target.value) }
                            name={ `${name}_en` }
                            value={ values[`${name}_en`] }
                            heightSize="60px"
                            type="text"
                            floatingLabelText={ floatingLabelText } />

                <TextFields arb
                            error={ touched && touched[`${name}_ar`] && errors &&  errors[`${name}_ar`] }
                            hide={ this.state.name.eng }
                            onBlur={ onBlur }
                            onChange={ e => onChange(`${name}_ar`, e.target.value) }
                            name={ `${name}_ar` }
                            value={ values[`${name}_ar`] }
                            heightSize="60px"
                            type="text"
                            floatingLabelText={ floatingLabelText } />

            </React.Fragment>
        );


        const activeClassNameEng = this.state.name.eng ? 'active': '';
        const activeClassNameArb = this.state.name.arb ? 'active': '';

        const errorClassNameEng = ( touched && touched[`${name}_en`] && errors && errors[`${name}_en`] ) ? 'tab-error': '';
        const errorClassNameArb = ( touched && touched[`${name}_ar`] && errors && errors[`${name}_ar`] ) ? 'tab-error' : '';

        const classNamesEn = activeClassNameEng +' '+ errorClassNameEng;
        const classNamesAr = activeClassNameArb +' '+ errorClassNameArb;
        return (
            <div className="tab-style">
                <ul className="tab-header">
                    <li className={ classNamesEn }
                        onClick={() => this.toggleTabsHandler(true) }>
                        <a>Eng</a>
                    </li>
                    <li className={ classNamesAr }
                        onClick={() => this.toggleTabsHandler(false) }>
                        <a>Arb</a>
                    </li>
                </ul>
                <div>{ fields }</div>
            </div>
        );
    }
}

export default InputTabs;



// WEBPACK FOOTER //
// ./src/components/UI/InputTabs-f.js